interface PSReportWarningsProps {
  runWarnings?: string[];
}
export const PSReportWarnings = ({runWarnings}: PSReportWarningsProps) => {
  if (!runWarnings || runWarnings.length < 1) {
    return null;
  }
  return (
    <div key="warnings" className="mb-3 text-muted" role="alert">
      <ul className="list-unstyled">
        {runWarnings.map((warning, i) => (
          <li key={`warning${i}`}>{warning}</li>
        ))}
      </ul>
    </div>
  );
};
